import script from "./PmMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PmMenu.vue?vue&type=script&setup=true&lang=js"

import "./PmMenu.vue?vue&type=style&index=0&id=4ffd6bb0&lang=scss"

const __exports__ = script;

export default __exports__